<template>
    <div>
        <bc-tooltip class="my-auto" v-if="!noButton">
            <template slot="activator">
                <v-btn icon @mouseup.left="openBarcode()" tabindex="-1">
                    <v-icon class="material-icons-outlined">{{ icon }}</v-icon>
                </v-btn>
            </template>
            {{ tooltip }}
        </bc-tooltip>
        <bc-dialog :value="barcode_dialog" :max-width="showDefaultSlot ? 800 : 500">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ headerText }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close @invoke-method="invokeMethod($event)" action="closeBarcode" :dialog-status="barcode_dialog"></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text class="px-0">
                    <v-container grid-list-form>
                        <v-layout row wrap class="black--text" v-if="!showOptionsSlot">
                            <v-flex :class="showDefaultSlot ? 'xs12 sm7' : 'xs12'" mx-auto>
                                <v-layout row mx-auto>
                                    <span :class="$bp.smallScreen ? 'display-2' : 'display-3'">{{ barcode_loader ? "Loading" : scanText }}</span>
                                    <div
                                        class="animation ml-4"
                                        :class="[barcode_loader ? 'dot-falling' : 'dot-typing', $bp.smallScreen ? 'mt-4' : 'mt-5']"
                                    ></div>
                                </v-layout>
                                <v-layout row mx-auto>
                                    <v-flex
                                        v-if="scanLabel"
                                        style="background: black; height: 120px; width: 120px"
                                        color="white"
                                        class="text-center text-uppercase pa-0"
                                    >
                                        <span
                                            style="
                                                height: 120px;
                                                min-width: 120px;
                                                font-family: tahoma;
                                                font-size: 100px;
                                                color: white;
                                                display: flex;
                                                align-items: center;
                                                justify-content: center;
                                            "
                                            >{{ scanLabel }}</span
                                        >
                                    </v-flex>
                                    <v-flex style="height: 120px; width: 120px">
                                        <v-icon class="display-4" style="font-family: Material Icons Outlined !important">{{ icon }}</v-icon>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm5 v-if="showDefaultSlot">
                                <template>
                                    <slot :remove="emitRemove" />
                                </template>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap v-else>
                            <v-flex xs12>
                                <slot></slot>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <slot name="delete-button"></slot>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeBarcode()">{{ $t("lang.cancel") }}</v-btn>
                    <slot name="button"></slot>
                </v-card-actions>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";

export default {
    props: {
        headerText: {
            type: String,
            default: "Part Lookup",
        },
        tooltip: {
            type: String,
            default: "Scan",
        },
        scanObject: {
            type: String,
            default: null,
        },
        showDefaultSlot: {
            type: Boolean,
            default: false,
        },
        showOptionsSlot: {
            type: Boolean,
            default: false,
        },
        scanLabel: {
            type: String,
            default: null,
        },
        scanText: {
            type: String,
            default: "Scan Barcode",
        },
        icon: {
            type: String,
            default: "qr_code_scanner",
        },
        noButton: {
            type: Boolean,
            default: false,
        },
        global: {
            type: Boolean,
            default: false,
        },
        snackbar: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            barcode_dialog: false,
            barcode_timer: "",
            barcode_loader: false,
            barcode_value: "",
            input_types: ["input", "select", "button", "textarea"],
        };
    },
    computed: {
        ...mapState({
            global_snackbar: (state) => state.settings.global_snackbar,
        }),
    },
    mounted() {
        // console.log('mounted', this.scanObject)
        if (this.global) {
            window.addEventListener("keydown", this.globalCheckKeydown);
            this.$emit("open");
        }
    },
    beforeDestroy() {
        // console.log('beforeDestroy', this.scanObject)
        window.removeEventListener("keydown", this.checkKeydown);
        if (this.global) window.removeEventListener("keydown", this.globalCheckKeydown);
    },
    methods: {
        openBarcode() {
            this.barcode_dialog = true;
            this.barcode_options = [];
            this.activateBarcode();
            this.$emit("open");
        },
        closeBarcode(emit = true) {
            this.barcode_dialog = false;
            this.barcode_loader = false;
            this.deactivateBarcode();
            if (emit) this.$emit("closed");
        },
        activateBarcode() {
            this.barcode_loader = false;
            this.barcode_value = "";
            // console.log(this.barcode_value)
            window.addEventListener("keydown", this.checkKeydown);
            if (this.global) window.removeEventListener("keydown", this.globalCheckKeydown);
        },
        deactivateBarcode() {
            window.removeEventListener("keydown", this.checkKeydown);
            if (this.global) window.addEventListener("keydown", this.globalCheckKeydown);
            clearTimeout(this.barcode_timer);
            this.barcode_timer = null;
        },
        resetBarcode(error = false) {
            this.deactivateBarcode();
            this.$nextTick(() => {
                this.activateBarcode();
                if (error) this.createAlert("error", "scan_again");
            });
        },
        // method to read in barcode input
        checkKeydown(e) {
            const key = e.key;
            if (e.repeat) {
                return;
            }
            if (key == "Enter") {
                this.deactivateBarcode();
                let value = null;
                try {
                    value = JSON.parse(this.barcode_value);
                } catch (e) {}
                // check if scanObject and required key are in value otherwise create scan error
                if (this.scanObject == "receiving" && value && value.part_id) {
                    this.$emit("scanned", value);
                } else if (this.scanObject == "part_number" && this.barcode_value) {
                    // could be scanning barcode string or qr code object containing part_number
                    this.$emit("scanned", this.barcode_value);
                } else if (this.scanObject == "user_qr_code" && this.barcode_value) {
                    // should be a value to save as users qr login
                    this.$emit("scanned", this.barcode_value);
                } else if ((this.scanObject == "work_orders_batch" || this.scanObject == "work_order") && value && value.work_order_id && value.batch_id) {
                    this.$emit("scanned", value);
                } else if (this.scanObject == "repack" && value && value.repack_id) {
                    this.$emit("scanned", value);
                } else {
                    this.$nextTick(() => {
                        this.activateBarcode();
                        if (this.dev_mode) {
                            console.error("SCAN ERROR");
                            console.error("scan was:", value);
                        }
                        if (value != null) {
                            // wrong label for this component
                            this.createAlert("error", "scan_again");
                        }
                    });
                }
                this.barcode_value = "";
            } else {
                // console.log(this.scanObject, 'checkKeydown', key)
                if (!this.barcode_loader) {
                    this.barcode_loader = true;
                    this.barcode_timer = setTimeout(() => {
                        this.resetBarcode(true);
                    }, 5000); // 5 seconds
                }
                if (key != "Shift") this.barcode_value += key;
            }
        },
        globalCheckKeydown(e) {
            const key = e.key;
            if (e.repeat) {
                return;
            }
            if (key == "Enter") {
                let value = null;
                try {
                    value = JSON.parse(this.barcode_value);
                } catch (e) {}
                // console.log('Enter', value)
                // check if scanObject and required key are in value otherwise create scan error
                let good_scan = null;
                if (this.scanObject == "receiving" && value && value.part_id) {
                    good_scan = value;
                } else if ((this.scanObject == "work_orders_batch" || this.scanObject == "work_order") && value && value.work_order_id && value.batch_id) {
                    good_scan = value;
                } else if (this.scanObject == "repack" && value && value.repack_id) {
                    good_scan = value;
                } else if (this.scanObject == "part_number" && this.barcode_value) {
                    // could be scanning barcode string or qr code object containing part_number
                    good_scan = this.barcode_value;
                }

                this.barcode_value = "";
                if (good_scan) {
                    this.$emit("scanned", good_scan);
                } else {
                    if (this.global_snackbar) this.$store.commit("toggleGlobalSnackbar", false);
                    this.barcode_value = "";
                    if (value != null) {
                        this.createAlert("error", "scan_again");
                    }
                }
            } else {
                // console.log(this.scanObject, 'globalCheckKeydown', key)
                // make sure barcode starts with {"
                if (key != "Shift") {
                    if (
                        (this.barcode_value == "" && key == "{") ||
                        (this.barcode_value.charAt(0) == "{" && ((this.barcode_value.length == 1 && key == '"') || this.barcode_value.charAt(1) == '"'))
                    ) {
                        this.barcode_value += key;
                        // console.log('real', this.barcode_value)
                        if (this.snackbar && !this.global_snackbar) this.$store.commit("toggleGlobalSnackbar", true);
                        // if scanning while a element is focused, unfocus the element
                        if (document.activeElement && this.input_types.includes(document.activeElement.tagName.toLowerCase())) {
                            document.querySelectorAll("input,textarea").forEach(function (element) {
                                if (element === document.activeElement) {
                                    return element.blur();
                                }
                            });
                        }
                    } else {
                        this.barcode_value = "";
                        if (this.global_snackbar) this.$store.commit("toggleGlobalSnackbar", false);
                    }
                }
            }
        },
        setLoader(value) {
            this.barcode_loader = value;
        },
        removeSelected(index) {
            this.$emit("removeSelected", index);
        },
        emitRemove(index) {
            this.$emit("remove", index);
        },
    },
};
</script>
